import { render, staticRenderFns } from "./RouteBreadcrumb.vue?vue&type=template&id=2fdfbc50&scoped=true"
import script from "./RouteBreadcrumb.vue?vue&type=script&lang=ts"
export * from "./RouteBreadcrumb.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdfbc50",
  null
  
)

export default component.exports